// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1_wh5","cls2":"WinBackPing-cls2_H7k WinBackPing-cls1_wh5"};